import { render, staticRenderFns } from "./ButtonAICompHandler.vue?vue&type=template&id=20df7f81&scoped=true"
import script from "./ButtonAICompHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonAICompHandler.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ButtonAICompHandler.vue?vue&type=style&index=0&id=20df7f81&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df7f81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/compass-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20df7f81')) {
      api.createRecord('20df7f81', component.options)
    } else {
      api.reload('20df7f81', component.options)
    }
    module.hot.accept("./ButtonAICompHandler.vue?vue&type=template&id=20df7f81&scoped=true", function () {
      api.rerender('20df7f81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ButtonAICompHandler.vue"
export default component.exports